// extracted by mini-css-extract-plugin
module.exports = {"darkmodeLabel":"DarkModeSwitch_darkmodeLabel__tLClP","darkmodeBall":"DarkModeSwitch_darkmodeBall__gd8sh","darkmodeCheckbox":"DarkModeSwitch_darkmodeCheckbox__2LgIf"};